import { Outlet } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BackToTop from '@/components/feature/BackToTop';

export default function SiteLayout() {
  return (
    <div id="top" className="flex min-h-screen w-full flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}